<!-- 车主信息上报接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/comUpwardStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "carOwnerList": [
                    {
                        "carNumber": 1,
                        "carportNumber": 0,
                        "customerAddress": "",
                        "customerName": "津M95621",
                        "customerRole": 0,
                        "customerSeq": 5,
                        "customerSex": 2,
                        "customerStatus": 1,
                        "customerTelphone": "15032166587",
                        "isDeleted": false
                    }
                ],
                "cmd": "reportCarOwner",
                "parkCode": "2KM9J7GC",
                "reportTime": "20170929160020"
            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "智慧停车开放平台主动上报停车场车主信息到第三方接入系统",
                urlPattern:this.commonUrls.third+"reportCarOwner",
                precondition: "VEMS 2.10.5及以上版本",
                fitSystem: "VEMS传统停车场",
                pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
                frequency:"实时触发",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'reportTime', info2: '是', info3: 'String', info4: '上报时间，yyyyMMddHHmmss' },
                        { info1: 'carOwnerList', info2: '是', info3: 'JSONArray', info4: '' }
                        ]
                },{
                    titleName: 'carOwnerList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'customerId', info2: '是', info3: 'String', info4: '车主ID，由外部平台生成的唯一编号' },
                        { info1: 'customerSeq', info2: '是', info3: 'int', info4: '车主在vems的递增序列号' },
                        { info1: 'customerName', info2: '是', info3: 'String', info4: '车主名' },
                        { info1: 'customerSex', info2: '是', info3: 'int', info4: '车主性别，0:男 1：女 2：未知' },
                        { info1: 'customerTelphone', info2: '是', info3: 'String', info4: '车主电话' },
                        { info1: 'customerRole', info2: '是', info3: 'int', info4: 'VIP客户角色，0无角色，用于扩充用户角色使用' },
                        { info1: 'carNumber', info2: '是', info3: 'int', info4: 'VIP客户拥有的VIP车辆数量' },
                        { info1: 'carportNumber', info2: '是', info3: 'int', info4: 'VIP拥有的车位数量' },
                        { info1: 'customerCompany', info2: '是', info3: 'String', info4: '公司' },
                        { info1: 'customerDepartment', info2: '是', info3: 'String', info4: '部门' },
                        { info1: 'customerAddress', info2: '是', info3: 'String', info4: '地址' },
                        { info1: 'remark', info2: '是', info3: 'String', info4: '备注' },
                        { info1: 'remark1', info2: '是', info3: 'String', info4: '备注1' },
                        { info1: 'remark2', info2: '是', info3: 'String', info4: '备注2' },
                        { info1: 'remark3', info2: '是', info3: 'String', info4: '备注3' },
                        { info1: 'identityCardNumber', info2: '是', info3: 'String', info4: '身份证号码' },
                        { info1: 'customerRoomNumber', info2: '是', info3: 'String', info4: '房间号' },
                        { info1: 'customerStatus', info2: '是', info3: 'int', info4: '0未启用，1启用，2禁用' },
                        { info1: 'lockKey', info2: '是', info3: 'String', info4: '数据唯一标识' },
                        { info1: 'isDeleted', info2: '是', info3: 'boolean', info4: '是否逻辑删除，false未删除，true删除' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [
                        ]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/upward/reportCarOwner.vue